var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c("div", { staticClass: "formTitle" }, [_vm._v("新增友情链接")]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "linkForm",
          attrs: {
            "label-width": "120px",
            model: _vm.swiperInfo,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-row",
            { staticClass: "margin24 link" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题：", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.swiperInfo.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.swiperInfo, "name", $$v)
                      },
                      expression: "swiperInfo.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "链接：", prop: "linkUrl" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.swiperInfo.linkUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.swiperInfo, "linkUrl", $$v)
                      },
                      expression: "swiperInfo.linkUrl",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "封面上传：" } },
                [_c("FileImg", { on: { successUpLoad: _vm.successUpLoad } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "submitBtn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.submit("linkForm")
                    },
                  },
                },
                [_vm._v("提交")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.isBack },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }